// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"146":"5900753e784807a8","149":"cd3eb04ce3c969f2","191":"91744e141a853223","244":"ff35acff4471840b","245":"35e093e6dffa359a","451":"82385130f21f7e79","453":"5b9326947a9ba9ad","569":"41e44d2b577b8cb2","664":"a79e607b83f3d0fa","710":"f9bed99402062578"}[chunkId] + ".js";
};